import React from 'react';
import { AlertCircle, Clock, Eye, CheckCircle, XCircle } from 'lucide-react';

const statusConfig = {
  'Open': { icon: AlertCircle, className: 'open' },
  'In Progress': { icon: Clock, className: 'in-progress' },
  'Under Review': { icon: Eye, className: 'under-review' },
  'Resolved': { icon: CheckCircle, className: 'resolved' },
  'Closed': { icon: XCircle, className: 'closed' }
};

export default function StatusBadge({ status }) {
  const config = statusConfig[status] || statusConfig['Open'];
  const Icon = config.icon;
  
  return (
    <span className={`status-badge ${config.className}`}>
      <Icon size={14} />
      {status}
    </span>
  );
}







